export default "__VITE_ASSET__DqEdtW_R__"